import React, { FC, RefObject, useEffect } from 'react'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import { RequestInputFiles } from '@utils/request'
import * as utilsList from './__index.utils'
import BlobUploader from '../inputs/azureBlobUploader.input'
import { documentStatusConfig } from './__documents.config'
import {
	isBalconySectionA,
	isBalconySectionB,
	isGR6_2SectionA,
	isGR6_2SectionB,
	isGR6_2SectionC,
	isGR6_2SectionD,
	isGR6_2SectionE,
	isGR6_2SectionF,
	isTypeOfWorkSectionA,
	isTypeOfWorkSectionB,
	isTypeOfWorkSectionC
} from './__index.utils'

const Step7Documents = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	isSummaryStep = false,
	// *******

	formFilesInputs,
	updateFileInput,
	updateUploadedFilesMap,
	onSetErrorFromFileComponent,

	// ********
	updateFileRequiredByDocumentsConfig,
	disabledBlobUploader,
	fieldWarnings,
	totalFilesCount,
	toPrint = false
}) => {
	const {
		whatToDo,
		isSubjectToPiiaApproval,
		hasBeenSubjectToApproval,
		// **********************
		mainUseOfExistingBuilding,
		isResidentialOrOther,
		typesOfWorkBalcony,
		// **********************
		useOfBuildingOrLand,
		typesOfWorkResidentialLand,
		typesOfWorkToPerformParking,
		// **********************
		typesOfWorkDiverse
	} = formInputs

	const {
		planImplantationArpenteurGrandeEmpriseInput,
		planImplantationFaitMainInput,
		planArchitecturePreliminaireInput,
		planAmenagementInput,
		planAmenagementPaysagerPreliminaireInput,
		ficheBatimentInput,
		planArchitectureInput,
		certificatDeLocalisationInput,
		planStructureInput,
		etudeAcoustiqueInput,
		engagementExemptDeContaminantInput,
		planIngenieurInput,
		planCivilInput,
		autresSiRequisInput
	} = formFilesInputs

	// check if isIA
	// to use value from summary answers or from inputForm.value
	enum PIIACateg {
		Q3TrueQ4True = 'Q3TrueQ4True',
		Q3TrueQ4False = 'Q3TrueQ4False',
		Q3False = 'Q3False'
	}

	const isPIIACategPermitDocument = () => {
		return isSubjectToPiiaApproval.value.toString() === 'true' &&
			hasBeenSubjectToApproval.value.toString() === 'true'
			? PIIACateg.Q3TrueQ4True
			: isSubjectToPiiaApproval.value.toString() === 'true' &&
			  hasBeenSubjectToApproval.value.toString() === 'false'
			? PIIACateg.Q3TrueQ4False
			: PIIACateg.Q3False
	}

	const resolveDocumentCasStatus = () => {
		switch (whatToDo.value.toString()) {
			// ********************************************
			//! isBalconyOrPorchPermitGR6_1
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_1BalconyOrPorch: {
				let Q8MainUseOfExistingBuilding =
					mainUseOfExistingBuilding.value.toString()

				let Q8_1IsResidentialOrOthers = isResidentialOrOther.value.toString()

				let Q11TypesOfWorkBalcony = typesOfWorkBalcony.value.toString()

				if (isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4False) {
					return documentStatusConfig.GR6_1BalconyOrPorch['IA-63']
				}

				if (Q8MainUseOfExistingBuilding == '') {
					return {}
				}

				// Si Q11= Ajout d'un balcon, d'une galerie, d'un perron ou d'un porche
				const Q11includesBalconyOption = isBalconySectionA(
					Q11TypesOfWorkBalcony
				)

				// Si Q11= Aménagement d'une terrasse
				const Q11includesTerrasseOption = isBalconySectionB(
					Q11TypesOfWorkBalcony
				)

				if (
					isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4True ||
					isPIIACategPermitDocument() == PIIACateg.Q3False
				) {
					switch (Q8MainUseOfExistingBuilding) {
						// Si Q8= Habitation unifamiliale ou Maison mobile
						case REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.firstOption:
						case REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.thirdOption:
							// Si Q11= Ajout d'un balcon, d'une galerie, d'un perron ou d'un porche
							// or Si Q11= Aménagement d'une terrasse
							if (Q11includesBalconyOption || Q11includesTerrasseOption) {
								return documentStatusConfig.GR6_1BalconyOrPorch['PA-5']
							}
							break

						// Q8= Bâtiment industriel, commercial, institutionnel ou mixte
						case REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.fourthOption:
							if (Q11includesBalconyOption || Q11includesTerrasseOption) {
								return documentStatusConfig.GR6_1BalconyOrPorch['PA-32']
							}
							break

						// Si Q8= Habitation de 2 logements et plus (duplex, ...)
						case REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.secondOption:
							if (Q11includesBalconyOption || Q11includesTerrasseOption) {
								return documentStatusConfig.GR6_1BalconyOrPorch['PA-19']
							}
							break

						default:
							return {}
							break
					}
				}
			}
			// ********************************************
			//! isResidentialLandPermitGR6_2
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit
				.GR6_2ResidentialLand: {
				let Q8MainUseOfBuilding = useOfBuildingOrLand.value.toString()
				let Q10TypesOfWork = typesOfWorkResidentialLand.value.toString()

				if (isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4False) {
					return documentStatusConfig.GR6_2ResidentialLand['IA-62']
				}

				if (Q8MainUseOfBuilding == '') {
					return {}
				}

				// Si Q10= preparationTerrain
				const isQ10includesPreparationTerrain = isGR6_2SectionA(Q10TypesOfWork)
				// Si Q10= remblaiDeblaiDecontamination
				const isQ10includesRemblaiDeblaiDecontamination =
					isGR6_2SectionB(Q10TypesOfWork)
				// Si Q10= ajoutDeplacementMuret
				const isQ10includesAjoutDeplacementMuret =
					isGR6_2SectionC(Q10TypesOfWork)
				// Si Q10= ajoutDeplacementMurSoutenement
				const isQ10includesAjoutDeplacementMurSoutenement =
					isGR6_2SectionD(Q10TypesOfWork)
				// Si Q10= bandeTampon
				const isQ10includesBandeTampon = isGR6_2SectionE(Q10TypesOfWork)
				// Si Q10= amenagementPaysagerGazonnement
				const isQ10includesAmenagementPaysagerGazonnement =
					isGR6_2SectionF(Q10TypesOfWork)

				if (
					isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4True ||
					isPIIACategPermitDocument() == PIIACateg.Q3False
				) {
					switch (Q8MainUseOfBuilding) {
						// Si Q8= Terrain ou bâtiment résidentiel
						case REQUEST_CONFIGS_KEYS.useOfBuildingOrLand.residential:
							// Si Q10 = SectionA (case1)
							if (isQ10includesPreparationTerrain) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-38']
							}
							// Si Q10 = SectionB (case2)
							if (isQ10includesRemblaiDeblaiDecontamination) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-13']
							}
							// Si Q10 = SectionC (case3) && SectionD (case4) && SectionE (case5) && SectionF (case6)
							if (
								(isQ10includesAjoutDeplacementMuret ||
									isQ10includesAjoutDeplacementMurSoutenement) &&
								(isQ10includesBandeTampon ||
									isQ10includesAmenagementPaysagerGazonnement)
							) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-6']
							}
							// Si Q10 = SectionC (case3) OR SectionD (case4)
							if (
								isQ10includesAjoutDeplacementMuret ||
								isQ10includesAjoutDeplacementMurSoutenement
							) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-12']
							}
							// Si Q10 = SectionE (case5) OR SectionF (case6)
							if (
								isQ10includesBandeTampon ||
								isQ10includesAmenagementPaysagerGazonnement
							) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-6']
							}

							break

						// Q8= Terrain ou bâtiment agricole, industriel, institutionnel, commercial ou mixte
						case REQUEST_CONFIGS_KEYS.useOfBuildingOrLand
							.agriculturalIndustrialInstitutionalCommercialOrMixed:
							// Si Q10 = SectionA (case1)
							if (isQ10includesPreparationTerrain) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-38']
							}
							// Si Q10 = SectionB (case2)
							if (isQ10includesRemblaiDeblaiDecontamination) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-13']
							}
							// Si Q10 = SectionC (case3) && SectionD (case4) && SectionE (case5) && SectionF (case6)
							if (
								(isQ10includesAjoutDeplacementMuret ||
									isQ10includesAjoutDeplacementMurSoutenement) &&
								(isQ10includesBandeTampon ||
									isQ10includesAmenagementPaysagerGazonnement)
							) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-24']
							}
							// Si Q10 = SectionC (case3) OR SectionD (case4)
							if (
								isQ10includesAjoutDeplacementMuret ||
								isQ10includesAjoutDeplacementMurSoutenement
							) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-12']
							}
							// Si Q10 = SectionE (case5) OR SectionF (case6)
							if (
								isQ10includesBandeTampon ||
								isQ10includesAmenagementPaysagerGazonnement
							) {
								return documentStatusConfig.GR6_2ResidentialLand['CA-24']
							}

							break

						default:
							return {}
							break
					}
				}
			}
			//
			//! isTypesOfWorkToPerformParkingGR6_3
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_3ParkingLot: {
				let Q8MainUseOfBuilding = mainUseOfExistingBuilding.value.toString()
				//Type de travaux
				let QtypesOfWorkToPerformParking =
						typesOfWorkToPerformParking.value.toString(),
					QisResidentialOrOther = isResidentialOrOther.value.toString()

				if (Q8MainUseOfBuilding == '') {
					return {}
				}

				if (isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4False) {
					return documentStatusConfig.GR6_3typesOfWorkToPerformParking['IA-62']
				} else if (
					(isPIIACategPermitDocument() == PIIACateg.Q3False ||
						isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4True) &&
					[
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.firstOption,
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.secondOption,
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.thirdOption
					].includes(Q8MainUseOfBuilding) &&
					[
						REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.firstOption,
						REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.thirdOption
					].includes(QtypesOfWorkToPerformParking)
				) {
					return documentStatusConfig.GR6_3typesOfWorkToPerformParking['CA-6']
				} else if (
					(isPIIACategPermitDocument() == PIIACateg.Q3False ||
						isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4True) &&
					REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.secondOption ==
						QtypesOfWorkToPerformParking
				) {
					return documentStatusConfig.GR6_3typesOfWorkToPerformParking['CA-36']
				} else if (
					(isPIIACategPermitDocument() == PIIACateg.Q3False ||
						isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4True) &&
					[
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.fourthOption,
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.fifthOption
					].includes(Q8MainUseOfBuilding) &&
					QisResidentialOrOther ==
						REQUEST_CONFIGS_KEYS.isResidentialOrOther.firstOption &&
					[
						REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.firstOption,
						REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.thirdOption
					].includes(QtypesOfWorkToPerformParking)
				) {
					return documentStatusConfig.GR6_3typesOfWorkToPerformParking['CA-24']
				} else if (
					(isPIIACategPermitDocument() == PIIACateg.Q3False ||
						isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4True) &&
					[
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.fourthOption,
						REQUEST_CONFIGS_KEYS.mainUseOfExistingBuilding.fifthOption
					].includes(Q8MainUseOfBuilding) &&
					QisResidentialOrOther ==
						REQUEST_CONFIGS_KEYS.isResidentialOrOther.secondOption &&
					[
						REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.firstOption,
						REQUEST_CONFIGS_KEYS.typesOfWorkToPerformParking.thirdOption
					].includes(QtypesOfWorkToPerformParking)
				) {
					return documentStatusConfig.GR6_3typesOfWorkToPerformParking['CA-6']
				}
			}

			//! typesOfWorkBoatGR6_4
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_4BoatDock: {
				let Q8MainUseOfBuilding = useOfBuildingOrLand.value.toString()

				if (Q8MainUseOfBuilding == '') {
					return {}
				}

				return documentStatusConfig.GR6_4TypesOfWorkBoat['CA-28']
			}
			//! typesOfWorkDiverseGR6_5
			case REQUEST_CONFIGS_KEYS.whatToDoLandDevWorkPermit.GR6_5Divers: {
				let Q8MainUseOfBuilding = useOfBuildingOrLand.value.toString()

				let Q8_1IsResidentialOrOthers = isResidentialOrOther.value.toString()

				let Q11TypesOfWorkDiverse = typesOfWorkDiverse.value.toString()

				const Q11IncludesScreen = isTypeOfWorkSectionA(Q11TypesOfWorkDiverse)

				const Q11IncludesOutdoor = isTypeOfWorkSectionB(Q11TypesOfWorkDiverse)

				const Q11IncludesFuel = isTypeOfWorkSectionC(Q11TypesOfWorkDiverse)

				if (Q8MainUseOfBuilding == '') {
					return {}
				}

				if (isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4False) {
					if (!Q11IncludesScreen && Q11IncludesFuel) {
						return documentStatusConfig.GR6_5TypesOfWorkDiverse['IA-63']
					} else {
						return documentStatusConfig.GR6_5TypesOfWorkDiverse['IA-62']
					}
				} else if (
					isPIIACategPermitDocument() == PIIACateg.Q3TrueQ4True ||
					isPIIACategPermitDocument() == PIIACateg.Q3False
				) {
					if (!Q11IncludesScreen && Q11IncludesFuel) {
						return documentStatusConfig.GR6_5TypesOfWorkDiverse['PA-41']
					} else if (Q11IncludesScreen) {
						return documentStatusConfig.GR6_5TypesOfWorkDiverse['CA-35']
					} else if (Q11IncludesOutdoor && Q8_1IsResidentialOrOthers !== '') {
						if (
							Q8_1IsResidentialOrOthers ==
							REQUEST_CONFIGS_KEYS.isResidentialOrOther.firstOption
						) {
							return documentStatusConfig.GR6_5TypesOfWorkDiverse['CA-24']
						} else if (
							Q8_1IsResidentialOrOthers ==
							REQUEST_CONFIGS_KEYS.isResidentialOrOther.secondOption
						) {
							return documentStatusConfig.GR6_5TypesOfWorkDiverse['CA-6']
						}
					} else {
						return documentStatusConfig.GR6_5TypesOfWorkDiverse['CA-6']
					}
				}
			}
			default:
				return {}
		}

		return {}
	}

	useEffect(() => {
		// update files required by the document status config
		const config = resolveDocumentCasStatus()

		updateFileRequiredByDocumentsConfig(config)
	}, [])

	const getDocumentStatus = (document: string, config): string => {
		const categoryConfig = config

		if (categoryConfig) {
			return categoryConfig[document] || 'not_required'
		}

		return 'not_required'
	}

	const isDocumentToShow = (document: string, config, status: string) => {
		return getDocumentStatus(document, config) == status
	}

	// a function to render RequestFiles on the DOCUMENT or Summary step
	const renderRequestFile = (
		input: RequestInputFiles,
		config,
		status: string
	) => {
		if (!isSummaryStep || (isSummaryStep && input.files.size > 0)) {
			return (
				isDocumentToShow(input.name, config, status) && (
					<BlobUploader
						name={input.name}
						subtitle={input.label}
						required={input.required}
						description={input.description}
						files={input.files}
						uploadedFilesMap={input.uploadedFilesMap}
						hasError={errors.includes(input.name)}
						onSetFiles={(files) => updateFileInput(input.name, files)}
						setUploadedFilesMap={(uploadedFilesMap) =>
							updateUploadedFilesMap(input.name, uploadedFilesMap)
						}
						maxFiles={input.numberMaxFiles}
						onSetHasError={onSetErrorFromFileComponent}
						isSummary={isSummaryStep}
						disabled={disabledBlobUploader}
						fieldWarnings={fieldWarnings}
						totalFilesCount={totalFilesCount}
						toPrint={toPrint}
					/>
				)
			)
		}
	}

	// show the files on the DOCUMENT step
	// @status : the status of the document (required or optionnal)
	// @isSummary : if the step is the summary step
	const renderRequestFiles = (status: string) => {
		const config = resolveDocumentCasStatus()
		return (
			<>
				{renderRequestFile(
					planImplantationArpenteurGrandeEmpriseInput,
					config,
					status
				)}
				{renderRequestFile(planImplantationFaitMainInput, config, status)}
				{renderRequestFile(certificatDeLocalisationInput, config, status)}
				{renderRequestFile(planAmenagementInput, config, status)}
				{renderRequestFile(
					planAmenagementPaysagerPreliminaireInput,
					config,
					status
				)}
				{renderRequestFile(planArchitecturePreliminaireInput, config, status)}
				{renderRequestFile(planArchitectureInput, config, status)}
				{renderRequestFile(planCivilInput, config, status)}
				{renderRequestFile(etudeAcoustiqueInput, config, status)}
				{renderRequestFile(engagementExemptDeContaminantInput, config, status)}
				{renderRequestFile(planIngenieurInput, config, status)}
				{renderRequestFile(planStructureInput, config, status)}
				{renderRequestFile(ficheBatimentInput, config, status)}
				{renderRequestFile(autresSiRequisInput, config, status)}
			</>
		)
	}

	return (
		<>
			{!isSummaryStep && (
				<>
					<h4 className={pageUtils.classes.h4}>
						{pageAssets?.request_form_required_documents}
					</h4>
					<span className={pageUtils.classes.fileInfo}>
						{pageAssets?.request_form_required_documents_description}
					</span>
				</>
			)}

			{renderRequestFiles('required')}
			{renderRequestFiles('optional')}
		</>
	)
}

export default Step7Documents
